/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { Link } from "react-router";

type PoaAgreementTextProps = {
  hasNoWinNoFeeClause?: boolean;
  lawFirmName?: string;
  multipleClients?: boolean;
};

const PoaAgreementText = ({
  hasNoWinNoFeeClause = false,
  lawFirmName = "Legalbird Rechtsanwälte Rechtsanwalts GmbH",
  multipleClients = false,
}: PoaAgreementTextProps) => {
  return (
    <span>
      {multipleClients ? "Wir sind" : "Ich bin"} damit einverstanden, dass die Legalbird GmbH ("Legalbird") als Diensteanbieter{" "}
      {multipleClients ? "unseres" : "meines"} Legalbird-Kontos {multipleClients ? "unsere" : "meine"} Dokumente und Korrespondenz an die Legalbird
      Rechtsanwälte Rechtsanwalts GmbH weiterleitet und abspeichert, um {multipleClients ? "uns" : "mir"} diese im Kundenbereich zur Verfügung stellen zu
      können. Ferner {multipleClients ? "entbinden wir" : "entbinde ich"} die Anwälte der Legalbird Rechtsanwälte Rechtsanwalts GmbH ausschließlich für die
      Übermittlung von Informationen an Legalbird sowie deren Beurteilung und Durchsetzung unwiderruflich von der anwaltlichen Schweigepflicht und{" "}
      {multipleClients ? "wünschen" : "wünsche"} ausdrücklich eine sofortige Bearbeitung {multipleClients ? "unseres" : "meines"} Falls vor Ablauf der
      Widerrufsfrist.
      <br />
      {multipleClients ? "Wir haben" : "Ich habe"} die{" "}
      <Link target={"_blank"} to={"/agb"}>
        AGB
      </Link>{" "}
      und die{" "}
      <Link target={"_blank"} to={"/datenschutz"}>
        Datenschutzerklärung
      </Link>{" "}
      der {lawFirmName}
      {hasNoWinNoFeeClause && (
        <>
          {" "}
          sowie die{" "}
          <Link target={"_blank"} to={"/agb-prozessfinanzierung"}>
            Legalbird AGB Prozessfinanzierung
          </Link>
        </>
      )}{" "}
      gelesen und {multipleClients ? "stimmen" : "stimme"} diesen zu.
    </span>
  );
};

export default PoaAgreementText;
